export const DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

export function todayISO() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}

export function dayName(date = new Date()) {
  return DAYS[(date.getDay() + 6) % 7];
}

export function prettyDate(value: string) {
  return new Date(`${value}T12:00:00`).toLocaleDateString('en-US',{month:'short',day:'numeric'});
}
